import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';
import { InfoBox } from './InfoBox';
import type { RowBoundary } from '../types/warehouse.types';

interface ViewInfoPanelProps {
  selectedPlaceIds: Set<string>;
  selectedRow: RowBoundary | null;
}

export const ViewInfoPanel: React.FC<ViewInfoPanelProps> = ({
  selectedPlaceIds,
  selectedRow,
}) => {
  const translate = useTranslate();
  return (
    <InfoBox
      title={translate('osfc.storage_ui.view_info.title')}
      style={{ maxWidth: "350px" }}
    >
      {selectedPlaceIds.size > 0 && (
        <>
          <Typography
            variant="body2"
            style={{
              margin: "0 0 8px 0",
              color: "#00BFFF",
              fontWeight: "bold",
            }}
          >
            🔍 {selectedPlaceIds.size !== 1
              ? translate('osfc.storage_ui.view_info.highlighted_plural', { count: selectedPlaceIds.size })
              : translate('osfc.storage_ui.view_info.highlighted', { count: selectedPlaceIds.size })}
          </Typography>
          <Typography
            variant="caption"
            style={{
              margin: "0 0 4px 0",
              color: "#00BFFF",
              opacity: 0.8,
            }}
          >
            {Array.from(selectedPlaceIds).slice(0, 5).join(", ")}
            {selectedPlaceIds.size > 5 && ` ${translate('osfc.storage_ui.view_info.more', { count: selectedPlaceIds.size - 5 })}`}
          </Typography>
        </>
      )}
      {selectedRow ? (
        <>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • <strong>{translate('osfc.storage_ui.view_info.2d_projection')}</strong> {selectedRow.label ? `${selectedRow.name} • ${selectedRow.label}`: selectedRow.name}
          </Typography>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • {translate('osfc.storage_ui.view_info.click_place_projection')}
          </Typography>
          <Typography variant="body2" style={{ margin: 0 }}>
            • {translate('osfc.storage_ui.view_info.click_outside')}
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • <strong>{translate('osfc.storage_ui.view_info.drag')}</strong> {translate('osfc.storage_ui.view_info.pan_view')}
          </Typography>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • <strong>{translate('osfc.storage_ui.view_info.ctrl_click')}</strong> {translate('osfc.storage_ui.view_info.multiple_selection')}
          </Typography>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • <strong>{translate('osfc.storage_ui.view_info.scroll')}</strong> {translate('osfc.storage_ui.view_info.zoom')}
          </Typography>
          <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
            • {translate('osfc.storage_ui.view_info.click_place')}
          </Typography>
          <Typography variant="body2" style={{ margin: 0 }}>
            • {translate('osfc.storage_ui.view_info.click_row')}
          </Typography>
        </>
      )}
    </InfoBox>
  );
};
